export const rate = (part: number, whole: number): number | null =>
	whole > 0 ? (part / whole) * 100 : null;

export const formatCount = (value: number): string =>
	value.toLocaleString("en-US");

export const formatPercent = (value: number | null, decimals = 1): string =>
	value === null ? "-" : `${value.toFixed(decimals)}%`;

export const formatRatio = (
	part: number,
	whole: number,
	decimals = 1,
): string => (whole > 0 ? (part / whole).toFixed(decimals) : "-");
